import { isNotNil } from '@wrisk/ui-components'
import { FunctionComponent } from 'react'

import { toVariantKBA, VehicleKBA } from '../../../domain'
import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const VehicleFormatterKBA: FunctionComponent<Formatter<VehicleKBA>> = ({
  value,
  t,
}) => (isNotNil(value) ? toVariantKBA(value) : t(tDefaults('inputs.no-answer')))
